<p-accordion>
    <p-accordion-panel value="0">
        <p-accordion-header>{{faq.question}}</p-accordion-header>
        <p-accordion-content><dynamic-template *ngIf="faq" [content]="faq.answer ?? ''"></dynamic-template></p-accordion-content>
    </p-accordion-panel>
</p-accordion>